function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconDoctor = function IconDoctor(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    width: "76",
    height: "100",
    viewBox: "0 0 76 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4716_15949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23438 99.9999V75.2641C2.23438 65.3248 10.2367 57.2744 20.1167 57.2744H22.352",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7641 99.9999V75.2641C73.7641 65.3248 65.7618 57.2744 55.8818 57.2744H53.6465",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5879 25.7923V34.7872C24.5879 42.2304 30.6008 48.2794 37.9997 48.2794C45.3985 48.2794 51.4114 42.2304 51.4114 34.7872V25.7923C51.4114 25.7923 42.4702 25.7923 40.2349 21.2949C37.9997 25.7923 24.5879 25.7923 24.5879 25.7923Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0586 46.0312V55.0261L37.9998 64.0209L46.9409 55.0261V46.0312",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1179 21.2954C20.1179 21.2954 19.7826 16.6181 22.3532 12.3006C29.059 1.05702 42.4708 -1.19169 51.412 7.80314C58.1179 14.5493 58.1179 23.5441 52.2837 28.109L51.412 30.2902",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3535 100V86.5078",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8232 73.016C28.0577 73.016 29.0585 72.0092 29.0585 70.7673C29.0585 69.5253 28.0577 68.5186 26.8232 68.5186C25.5887 68.5186 24.5879 69.5253 24.5879 70.7673C24.5879 72.0092 25.5887 73.016 26.8232 73.016Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8242 68.5176V59.5228L29.0595 55.0254",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 27C54.66 27 57 27.68 57 31C57 35 52.66 37 51 37",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 27C21.34 27 19 27.68 19 31C19 35 23.34 37 25 37",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6465 100V86.5078",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1767 70.7663V59.5228L46.9414 55.0254",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4707 77.5127C42.4707 73.7799 45.466 70.7666 49.1766 70.7666C52.8872 70.7666 55.8825 73.7799 55.8825 77.5127",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4716_15949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "76",
    height: "100",
    fill: "white"
  }))));
};